/**
 * Tarjetas de «Espacios de conversación» de la landing (`#cm-home`, custom_header).
 *
 * Viven FUERA del arbol de Mithril (son hermanas de `#app`, ver `forum.blade.php`), asi que
 * todo lo que las toca lo hace por DOM. Este modulo centraliza las dos cosas que mas de un
 * sitio necesita saber de ellas: como encontrarlas y a que categoria apunta cada una.
 */
export const CARD_SELECTOR = '#cm-home a.cm-cat-card[href]';

/**
 * Los CTAs de las DOS PUERTAS de la landing (`.cm-gate.cm-a` = Umbral, `.cm-gate.cm-b` = n8n).
 *
 * Se buscan por los DOS estados posibles del atributo, no solo por el de origen: `data-cm-signup`
 * es como los escribe el HTML y `data-cm-entrar` es como los deja `retargetLandingLinks` cuando
 * hay sesion. Buscar solo el primero haria la reescritura de ida y no la de vuelta — al cerrar
 * sesion el boton se quedaria diciendo «Entrar» para siempre.
 *
 * NO se filtra por `.cm-btn` ni por `cm-primary`/`cm-n8n`: esas clases son pintado y podrian
 * cambiar con el tema sin que cambie lo que el boton significa.
 */
export const GATE_CTA_SELECTOR = '#cm-home .cm-gate a[data-cm-signup], #cm-home .cm-gate a[data-cm-entrar]';

/**
 * Destino ORIGINAL de la tarjeta, tal como lo escribio el HTML de la landing.
 *
 * `data-cm-href` lo deja `retargetLandingLinks` cuando reescribe un destino: sin esa copia,
 * una tarjeta ya reescrita perderia su slug y ni los contadores ni el propio reescritor
 * podrian volver sobre ella (p. ej. al iniciar sesion y pasar a ver la categoria).
 */
export function originalHref(card: HTMLAnchorElement): string {
  return card.getAttribute('data-cm-href') || card.getAttribute('href') || '';
}

/**
 * Slug de la categoria a partir de `/t/<slug>`, tolerando query, hash, barra final y acentos
 * percent-encoded. Devuelve `null` si el destino no es una categoria.
 */
export function slugFromHref(href: string): string | null {
  const path = href.split('?')[0].split('#')[0];
  const match = path.match(/\/t\/([^/]+)\/?$/);

  if (!match) return null;

  try {
    return decodeURIComponent(match[1]);
  } catch (e) {
    return match[1];
  }
}

/** Slug de la categoria de una tarjeta, mirando siempre su destino original. */
export function cardSlug(card: HTMLAnchorElement): string | null {
  return slugFromHref(originalHref(card));
}
